import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Placeholder,
} from "react-bootstrap";
import { FormGroup, Label, Input, FormText } from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useFieldArray, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import {
  GET_HOTELS_LIST_FOR_FULL_PANEL_HANDLE_API,
  HOTELLIST,
  ROOMADD,
  ROOMESSENTAILLIST,
  ROOMLIST,
  ROOMTYPE,
  ROOMTYPELIST,
  ROOMUPDATE,
} from "../../../../services/ApiCalls";
import Loader from "../../../../components/Common/Loader";
import { useTranslation } from "react-i18next";
import multipleFileUploader from "../../../../utilities/multipleFileUploader";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";

const roomSchema = z.object({
  hotelId: z.string().nonempty("Hotel is required"),
  // checkInHour: z.string().min(1, "Check-in hour is required"),
  // checkOutHour: z.string().min(1, "Check-out hour is required"),
  type: z.string().nonempty("Room type is required"),
  floorNumber: z.coerce
    .number()
    .int("Floor number must be an integer")
    .min(1, "Floor number must be greater than 0"),

  maxOccupancy: z.coerce
    .number()
    .int("Max occupancy must be an integer")
    .min(1, "Number of people must be greater than 0"),

  length: z.coerce
    .number()
    .int("Length must be an integer")
    .min(1, "Length is required"),

  width: z.coerce
    .number()
    .int("Width must be an integer")
    .min(1, "Width is required"),

  roomNumber: z
    .string()
    .min(1, "Room number is required")
    .refine((val) => /^\d+$/.test(val) && Number(val) > 0, {
      message: "Room number must be a valid number greater than 0",
    }),

  // numberOfBed: z
  //   .string()
  //   .nonempty("Number of beds is required")
  //   .regex(/^\d+$/, "Number of beds must be an integer")
  //   .refine((val) => parseInt(val, 10) >= 1, {
  //     message: "Number of beds must be at least 1",
  //   }),
  housekeepingNotes: z.string().optional(),
  roomImages: z
    .array(z.string())
    .min(1, "At least one image is required"),
  amenities: z.array(z.string()).min(1, "Select at least one amenity"),
  status: z.enum(["Available", "Occupied", "Maintenance"], {
    required_error: "Status is required",
  }),
  bedType: z
    .string()
    .nonempty("Bed Type is required"),
  // refundPolicy: z.object({
  //   type: z
  //     .enum(["Non-refundable", "Full Refund", "Partial Refund"])
  //     .optional(),
  //   description: z.string().max(500).optional(),
  //   cutoffHours: z.coerce.number().min(1).optional(),
  // }),
  // pricing: z
  //   .array(
  //     z.object({
  //       durationType: z.string().nonempty("Duration type is required"),
  //       basePrice: z.coerce.number().min(0, "Base price must be positive"),
  //       weekRate: z.coerce.number().min(0, "Week rate cannot be negative"),
  //       discount: z
  //         .number()
  //         .min(0, { message: "Discount cannot be negative" })
  //         .max(100, { message: "Discount cannot exceed 100%" }),
  //       activated: z.boolean().optional(),
  //       refundable: z.boolean().optional(),
  //     })
  //   )
  //   .min(1, "At least one pricing entry is required"),
});

const AddRoom = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const navigate = useNavigate();
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imgloader, setImgLoader] = useState(false);
  const [roomAmenities, setRoomAmenities] = useState([]);
  const [hotelAdminData, setHotelData] = useState([]);
  const [roomTypeData, setRoomTypeData] = useState([]);
  const [hotelDetailData, setHotelDetailData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [roomModel, setRoomModel] = useState(false);


  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(roomSchema),
    defaultValues: {
      hotelId: "",
      amenities: [],
      floorNumber: "",
      roomNumber: "",
      roomImages: [],
      // numberOfBed: "",
      bedType: "",
      type: "",
      status: "Available",
      // checkInHour: "",
      // checkOutHour: "",
      maxOccupancy: "",
      length: "",
      width: "",
      housekeepingNotes: "",
    },
  });
  const selectedHotelId = watch("hotelId");


  const getAmenityData = catchAsync(async () => {
    const [roomRes, hotelRes] = await Promise.all([
      ROOMESSENTAILLIST({ limit: 100, page: 1, status: "Active" }),
      GET_HOTELS_LIST_FOR_FULL_PANEL_HANDLE_API(),


    ]);


    checkResponse({ res: roomRes, setData: setRoomAmenities });
    checkResponse({ res: hotelRes, setData: setHotelData });
    if (!id) {
      setValue("hotelId", localStorage.getItem("hotelId"))
    }
  });

  console.log("dfsdgdgdgege", roomTypeData);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await ROOMLIST({ id: id });
    const success = checkResponse({
      res,
      setData: setHotelDetailData,
      setLoader,
    });
    if (success && res?.data?.data) {
      const data = res.data.data;
      console.log(data, "data====<>");
      setImagePreviews(data.roomImages || []);
      reset({
        hotelName: data?.hotelId?.hotelName || "",
        hotelId: data.hotelId?._id || "",
        amenities: data.amenities?.map((a) => a._id) || [],
        floorNumber: data.floorNumber || "",
        roomNumber: data.roomNumber || "",
        bedType: data.bedType || "",
        // numberOfBed: data.numberOfBed != null ? String(data.numberOfBed) : "",
        type: data?.type?._id || "",
        status: data.status || "Available",
        // checkInHour: data?.checkInHour || "",
        // checkOutHour: data?.checkOutHour || "",
        maxOccupancy: data?.maxOccupancy || "",
        length: data?.length || "",
        width: data?.width || "",
        housekeepingNotes: data?.housekeepingNotes || "",
        roomImages: data?.roomImages?.map((ele) => ele?._id) || [],
        // pricing: data?.pricing?.length
        //   ? data?.pricing
        //   : [
        //     {
        //       durationType: "",
        //       basePrice: 0,
        //       weekRate: 0,
        //       discount: 0,
        //       activated: true,
        //       refundable: true,
        //     },
        //   ],
        // refundPolicy: {
        //   type: data?.refundPolicy?.type || "",
        //   description: data?.refundPolicy?.description || "",
        //   cutoffHours: data?.refundPolicy?.cutoffHours || "",
        // },
      });
    }
  }, setLoader);

  useEffect(() => {
    getAmenityData();
    if (id) {
      getData();
    }
  }, [id]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "pricing",
  });

  const handleCheckbox = (field, value, checked) => {
    const currentValues = watch("amenities") || [];
    let updated;
    if (checked) {
      updated = [...currentValues, value];
    } else {
      updated = currentValues.filter((id) => id !== value);
    }
    setValue("amenities", updated, { shouldValidate: true });
  };

  const handleImageChange = catchAsync(async (e) => {
    setImgLoader(true);

    const files = Array.from(e.target.files);
    for (let file of files) {
      const res = await multipleFileUploader(file);

      if (Array.isArray(res)) {
        const currentIds = watch("roomImages") || [];
        const newIds = res.map((img) => img._id);
        setValue("roomImages", [...currentIds, ...newIds], {
          shouldValidate: true,
        });
        setImagePreviews((prev) => [...prev, ...res]);
      }
    }

    setImgLoader(false);
  });

  const handleRemoveImage = (index) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== index));
    const currentIds = watch("roomImages") || [];
    const updatedIds = currentIds.filter((_, i) => i !== index);

    setValue("roomImages", updatedIds, { shouldValidate: true });
  };


  const submitHandler = catchAsync(async (data) => {
    console.log("data.roomImages", data.roomImages);

    const body = {
      ...data,
      roomImages: data.roomImages?.map((ele) => ele?._id ?? ele), // already array of IDs
      ...(id && { _id: id }),
    };

    const res = await (id ? ROOMUPDATE(body) : ROOMADD(body));
    const success = checkResponse({ res, showSuccess: true });
    if (success) navigate(`/room?page=${page}`);
  });

  const handleCancel = () => navigate(`/room?page=${page}`);
  console.log(hotelDetailData, "data values===<>");
  console.log(errors, "eroror");


  const fetchRoomType = async () => {
    const resp = await ROOMTYPELIST({ limit: 100, page: 1, hotelId: selectedHotelId });
    if (resp?.data?.data?.length <= 0) {
      setRoomModel(true)
    }
    checkResponse({ res: resp, setData: setRoomTypeData });
  }

  useEffect(() => {
    if (selectedHotelId) {
      fetchRoomType();
    }
  }, [selectedHotelId])

  return (
    <>
      <ConfirmationPop
        type={"addRoomType"}
        confirmation={roomModel}
        setConfirmation={() =>
          setRoomModel(false)
        }
        confirmHandler={() =>
          navigate("/roomtype/add")
        }
      />
      {loader && <Loader />}
      <section className="addRoom position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to={`/room?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id ? t("manageRoom.editRoom") : t("manageRoom.addRoom")}
                </h4>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div>
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="6" className="my-2">
                      <label>{t("manageRoom.selectHotel")}</label>
                      <select className="form-control" {...register("hotelId")}>
                        <option value="">-- Select Hotel --</option>
                        {hotelAdminData?.hotelList?.map((admin) => (
                          <option key={admin.id} value={admin.id}>
                            {admin.name}
                          </option>
                        ))}
                      </select>
                      {errors?.hotelId && (
                        <p className="text-danger">{errors.hotelId.message}</p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageRoom.columns.floorNumber")}</label>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        {...register("floorNumber", {
                          valueAsNumber: true,
                          min: 0,
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.floorNumber && (
                        <p className="text-danger">
                          {errors.floorNumber.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageRoom.roomNumber")}</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("roomNumber", {
                          required: "Room number is required",
                          validate: (value) => {
                            if (!/^\d+$/.test(value)) {
                              return "Room number must be a valid number";
                            }
                            if (Number(value) < 1) {
                              return "Room number must be greater than 0";
                            }
                            return true;
                          },
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.roomNumber && (
                        <p className="text-danger">
                          {errors.roomNumber.message}
                        </p>
                      )}
                    </Col>

                    {/* <Col lg="6" className="my-2">
                      <label>{t("manageRoom.numberOfBed")}</label>
                      <input
                        type="text"
                        className="form-control"
                        min={1}
                        {...register("numberOfBed")}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.numberOfBed && (
                        <p className="text-danger">
                          {errors.numberOfBed.message}
                        </p>
                      )}
                    </Col> */}
                    <Col lg="6" className="my-2">
                      <label>{t("manageRoom.columns.bedType")}</label>

                      <Form.Select {...register("bedType")}>
                        <option value="">Select Bed Type</option>
                        <option value="Queen">Queen</option>
                        <option value="Twin">Twin</option>
                        <option value="King">King</option>
                      </Form.Select>
                      {errors.bedType && (
                        <p className="text-danger">
                          {errors.bedType.message}
                        </p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label> {t("manageRoom.roomType")}
                        <span style={{ color: "red", fontSize: 12, marginLeft: 5 }} >{!watch("hotelId") && t("manageRoom.columns.selectHotel")} </span></label>
                      <select key={JSON.stringify(roomTypeData)} className="form-control" {...register("type")}>
                        <option value="">-- Select Room Type --</option>
                        {roomTypeData?.map((admin) => (
                          <option key={admin._id} value={admin._id}>
                            {admin.roomType.name}
                          </option>
                        ))}
                      </select>
                      {errors?.type && (
                        <p className="text-danger">{errors.type.message}</p>
                      )}
                    </Col>

                    <Col lg="6" className="my-2">
                      <label>{t("manageRoom.columns.status")}</label>

                      <Form.Select {...register("status")}>
                        <option value="">Select Availability</option>
                        <option value="Available">Available</option>
                        <option value="Unavailable">Unavailable</option>
                        <option value="Maintenance">Maintenance</option>
                      </Form.Select>
                    </Col>
                    {/* <Col lg="6" className="my-2">
                      <label>
                        {t("manageHotel.checkInHour", "CheckInHour")}
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        {...register("checkInHour")}
                      />
                      {errors?.checkInHour && (
                        <p className="text-danger">
                          {errors.checkInHour.message}
                        </p>
                      )}
                    </Col> */}
                    {/* <Col lg="6" className="my-2">
                      <label>
                        {t("manageHotel.checkOutHour", "CheckOutHour")}
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        {...register("checkOutHour")}
                      />
                      {errors?.checkOutHour && (
                        <p className="text-danger">
                          {errors.checkOutHour.message}
                        </p>
                      )}
                    </Col> */}

                    <Col lg="12" className="my-2">
                      <label>{t("manageRoom.housekeepingNotes")}</label>
                      <textarea
                        rows={3}
                        className="form-control"
                        {...register("housekeepingNotes")}
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label>
                        {t("manageRoom.columns.numberOfPeople", "People Allowed")}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        {...register("maxOccupancy", {
                          valueAsNumber: true,
                          min: 0,
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.maxOccupancy && (
                        <p className="text-danger">
                          {errors.maxOccupancy.message}
                        </p>
                      )}
                    </Col>
                    <Col lg="6" className="my-2">
                      <label>
                        {t("manageRoom.columns.roomLength", "Room Length (meter)")}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        {...register("length", {
                          valueAsNumber: true,
                          min: 0,
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.length && (
                        <p className="text-danger">{errors.length.message}</p>
                      )}
                    </Col>
                    <Col lg="6" className="my-2">
                      <label>
                        {t("manageRoom.columns.roomWidth", "Room Width (meter)")}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        {...register("width", {
                          valueAsNumber: true,
                          min: 0,
                        })}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                      />
                      {errors.width && (
                        <p className="text-danger">{errors.width.message}</p>
                      )}
                    </Col>

                    <Col lg="12" className="my-2">
                      <label className="fw-semibold">{t("manageRoom.columns.roomAmenities")}</label>
                      <div
                        className="d-flex flex-wrap gap-3 p-2 border rounded"
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {roomAmenities?.length > 0
                          ? roomAmenities.map((amenity) => (
                            <div
                              key={amenity._id}
                              className="checkboxlebels d-flex align-items-center"
                              style={{ minWidth: "150px" }}
                            >
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    className="chekboxCustom"
                                    label={amenity.name}
                                    checked={watch("amenities")?.includes(
                                      amenity._id
                                    )}
                                    onChange={(e) =>
                                      handleCheckbox(
                                        "amenities",
                                        amenity._id,
                                        e.target.checked
                                      )
                                    }
                                  />{" "}
                                  {amenity.name}
                                </Label>
                              </FormGroup>
                            </div>
                          ))
                          : Array.from({ length: 6 }).map((_, idx) => (
                            <Placeholder key={idx} xs={8} bg="secondary" />
                          ))}
                      </div>
                      {errors.amenities && (
                        <p className="text-danger">
                          {errors.amenities.message}
                        </p>
                      )}
                    </Col>
                    {/* <Col lg="6" className="my-3">
                      <label className="fw-bold text-muted ps-2 m-0">
                        Refund Policy
                      </label>
                      <div className="p-3 border rounded bg-white shadow-sm">
                        <Form.Select
                          {...register("refundPolicy.type")}
                          className="mb-3"
                        >
                          <option value="">Select Refund Policy</option>
                          <option value="Non-refundable">Non-refundable</option>
                          <option value="Full Refund">Full Refund</option>
                          <option value="Partial Refund">Partial Refund</option>
                        </Form.Select>
                        {errors?.refundPolicy?.type && (
                          <p className="text-danger small">
                            {errors.refundPolicy.type.message}
                          </p>
                        )}

                        {["Full Refund", "Partial Refund"].includes(
                          watch("refundPolicy.type")
                        ) && (
                            <>
                              <Form.Control
                                type="number"
                                placeholder="Enter cutoff hours"
                                className="mb-3"
                                {...register("refundPolicy.cutoffHours", {
                                  valueAsNumber: true,
                                })}
                              />
                              {errors?.refundPolicy?.cutoffHours && (
                                <p className="text-danger small">
                                  {errors.refundPolicy.cutoffHours.message}
                                </p>
                              )}
                            </>
                          )}

                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Add description (optional)"
                          className="mb-2"
                          {...register("refundPolicy.description")}
                        />
                        {errors?.refundPolicy?.description && (
                          <p className="text-danger small">
                            {errors.refundPolicy.description.message}
                          </p>
                        )}
                      </div>
                    </Col> */}

                    <Col lg="12" className="my-2">
                      <div
                        className="formWrpper rounded p-3"
                        style={{ background: "#f9f9f9" }}
                      >
                        <label className="fw-bold text-muted ps-2 m-0">
                          {t("roomType.columns.uploadImages")}
                        </label>
                        <div
                          className="border border-2 border-dashed rounded d-flex flex-column align-items-center justify-content-center p-4 bg-light"
                          style={{ cursor: "pointer", minHeight: "140px" }}
                          onClick={() =>
                            document.getElementById("imageUploadInput").click()
                          }
                        >
                          <i className="bi bi-cloud-upload fs-1 text-muted"></i>
                          <p className="m-0 text-muted">
                            {t("roomType.columns.imageLabel")}
                          </p>
                          <input
                            id="imageUploadInput"
                            type="file"
                            accept="image/*"
                            multiple
                            className="d-none"
                            onChange={handleImageChange}
                          />
                        </div>

                        {errors.roomImages && (
                          <p className="text-danger mt-1">
                            {errors.roomImages.message}
                          </p>
                        )}

                        <div className="d-flex flex-wrap gap-2 mt-3">
                          {imgloader ? (
                            <div
                              style={{ height: 120, width: 120 }}
                              className="d-flex align-items-center justify-content-center border rounded"
                            >
                              Loading...
                            </div>
                          ) : (
                            imagePreviews.map((img, index) => (
                              <div
                                key={img._id}
                                style={{ width: 120, height: 120, position: "relative" }}
                                className="border rounded overflow-hidden shadow-sm"
                              >
                                <img
                                  src={img.link}
                                  alt={`preview-${index}`}
                                  className="w-100 h-100 object-fit-cover"
                                />

                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                                  onClick={() => handleRemoveImage(index)}
                                >
                                  ✕
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </Col>

                    {/* <Col lg="12" className="my-2">
                      <div
                        className="formWrpper rounded p-3"
                        style={{ background: "#f9f9f9" }}
                      >
                        <span className="fw-bold mb-2 d-block">
                          {t("manageRoom.addPrice")}
                        </span>

                        <Row>
                          <Col lg="12" className="my-2">
                            <Row className="fw-semibold text-muted border-bottom pb-2 mb-2">
                              <Col md={2}>Duration Type</Col>
                              <Col md={2}>Week Rate</Col>
                              <Col md={2}>Weekend Rate</Col>
                              <Col md={2}>Discount</Col>
                              <Col md={3}>Options</Col>
                              <Col md={1}></Col>
                            </Row>

                            {fields.map((field, index) => (
                              <Row
                                key={field.id}
                                className="align-items-end mb-3"
                              > 
                               <Col md={2}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(
                                      `pricing.${index}.durationType`
                                    )}
                                    placeholder="Duration"
                                  />
                                  {errors.pricing?.[index]?.durationType && (
                                    <p className="text-danger small mb-0">
                                      {
                                        errors.pricing[index].durationType
                                          .message
                                      }
                                    </p>
                                  )}
                                </Col> 
                                <Col md={2}>
                                  <Form.Select
                                    className="scrollable-select"
                                    {...register(
                                      `pricing.${index}.durationType`,
                                      {
                                        required: t(
                                          "validation.durationTypeRequired"
                                        ),
                                      }
                                    )}
                                  >
                                    <option value="">Select Duration</option>
                                    {[
                                      "2hour",
                                      "3hour",
                                      "4hour",
                                      "5hour",
                                      "6hour",
                                      "12hour",
                                      "overnight",
                                      "1d",
                                      "2d",
                                      "3d",
                                      "7d",
                                      "15d",
                                      "30d",
                                    ].map((d) => (
                                      <option key={d} value={d}>
                                        {d
                                          .replace(/(\d+)([a-z]+)/, "$1 $2")
                                          .toUpperCase()}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </Col>
                                <Col md={2}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register(`pricing.${index}.basePrice`, {
                                      valueAsNumber: true,
                                      min: {
                                        value: 0,
                                        message: t(
                                          "validation.basePriceNegative"
                                        ),
                                      },
                                    })}
                                    min={0}
                                    placeholder="Week Rate"
                                  />
                                  {errors.pricing?.[index]?.basePrice && (
                                    <p className="text-danger small mb-0">
                                      {errors.pricing[index].basePrice.message}
                                    </p>
                                  )}
                                </Col>

                                <Col md={2}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register(`pricing.${index}.weekRate`, {
                                      valueAsNumber: true,
                                      min: {
                                        value: 0,
                                        message: t(
                                          "validation.discountNegative"
                                        ),
                                      },
                                    })}
                                    min={0}
                                    placeholder="Weekend Rate"
                                  />
                                  {errors.pricing?.[index]?.weekRate && (
                                    <p className="text-danger small mb-0">
                                      {errors.pricing[index].weekRate.message}
                                    </p>
                                  )}
                                </Col>

                                <Col md={2}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register(`pricing.${index}.discount`, {
                                      valueAsNumber: true,
                                      min: {
                                        value: 0,
                                        message: t(
                                          "validation.discountNegative"
                                        ),
                                      },
                                      max: {
                                        value: 100,
                                        message: t("validation.discountExceed"),
                                      },
                                    })}
                                    min={0}
                                    max={100}
                                    placeholder="Discount %"
                                  />
                                  {errors.pricing?.[index]?.discount && (
                                    <p className="text-danger small mb-0">
                                      {errors.pricing[index].discount.message}
                                    </p>
                                  )}
                                </Col>

                                <Col
                                  md={3}
                                  className="checkboxlebels d-flex align-items-center gap-3 py-2 justify-content-start"
                                >
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="checkbox"
                                        className="chekboxCustom"
                                        {...register(
                                          `pricing.${index}.activated`
                                        )}
                                      />{" "}
                                      {t("manageRoom.activated", "Activated")}
                                    </Label>
                                  </FormGroup>

                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="checkbox"
                                        className="chekboxCustom"
                                        {...register(
                                          `pricing.${index}.refundable`
                                        )}
                                      />{" "}
                                      {t("manageRoom.refundable")}
                                    </Label>
                                  </FormGroup>
                                </Col>

                                <Col md={1} className="p-0">
                                  <Button
                                    variant="danger"
                                    onClick={() => remove(index)}
                                  >
                                    {t("common.remove")}
                                  </Button>
                                </Col>
                              </Row>
                            ))}

                            <Button
                              variant="primary"
                              onClick={() =>
                                append({
                                  durationType: "",
                                  basePrice: 0,
                                  weekRate: 0,
                                  discount: 0,
                                  activated: true,
                                  refundable: true,
                                })
                              }
                            >
                              {t("common.addRate")}
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Col>*/}

                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          type="button"
                          onClick={handleCancel}
                          className="commonBtn GreyBtn"
                        >
                          {t("common.cancel")}
                        </Button>
                        <Button type="submit" className="commonBtn">
                          {loader ? "Submitting..." : t("common.submit")}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section >
    </>
  );
};

export default AddRoom;
